"use client";
import * as React from "react";
const SvgExploreSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 7.12a.9.9 0 0 0-.88.88c0 .49.4.88.88.88s.88-.4.88-.88A.9.9 0 0 0 8 7.12M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m1.75 9.75L3.2 12.8l3.05-6.55L12.8 3.2z" }));
export {
  SvgExploreSharp as default
};
